import React from "react";
import "./App.css"; 
import "./index.css"; 
import { Routes, Route } from "react-router-dom"; 
import Header from "./Components/Header"; 
import Home from "./Pages/Home"; 
import Jobs from "./Pages/Jobs"; 
import Careers from "./Components/Job/Careers"; 
import Form from "./Components/Form"; 
import Porr from "./Pages/Porr"; 
import LowerAustria from "./Pages/LowerAustria";
import PVA from "./Pages/PVA";
import BRZ from "./Pages/BRZ";
import ScrollToHash from "./Components/ScrollToHash";
import ScrollToTop from "./Components/ScrollToTop"; 

function App() {
  return (
    <>
      <Header />
      <ScrollToTop />     
      <ScrollToHash />    
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/form" element={<Form />} />
        <Route path="/porr" element={<Porr />} />
        <Route path="/loweraustria" element={<LowerAustria />} />
        <Route path="/pva" element={<PVA />} />
        <Route path="/brz" element={<BRZ />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default App;




